import { createContext } from 'react';
import { GlobalData } from '../cms';
import { Audience } from '../const';

export const GlobalContext = createContext<GlobalData>({
  homepageLinks: [],
  navigationAudiencesButton: undefined,
  navigation: [],
  navigationHighlights: [],
  menuQuickLinks: [],
  footerLinkGroups: [],
  footerLegalLinks: [],
  footerForm: undefined,
  footerPaymentPartners: {
    id: 0,
    text: '',
    partnerLogosEntries: [],
  },
  footerPartners: {
    id: 0,
    text: '',
    partnerLogosEntries: [],
  },
  footerLogisticPartners: {
    id: 0,
    text: '',
    partnerLogosEntries: [],
  },
  footerCertificates: {
    id: 0,
    text: '',
    partnerLogosEntries: [],
  },
  footerContactSectionHeadline: '',
  footerContactSectionText: '',
  footerContactSectionLink: {},
  footerSpecialLink: {},
  socialLinks: [],
  audience: Audience.Default,
  audiences: [],
  setAudience: () => ({}),
  audienceIsLoaded: false,
  metaTitle: '',
  metaDescription: '',
  metaImage: {
    id: 0,
    url: '',
    alternativeText: '',
    type: 'image',
    width: 0,
    height: 0,
    ext: '',
    hash: '',
  },
  robots: '',
});
